module.exports = __webpack_public_path__ + "img/Icon-Reading.28abfc5f.svg";